mutation HardDeleteContact($contactId: ID!) {
    contactHardDelete(contactId: $contactId) {
        success
    }
}
